import React from 'react';
import { TableCell, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { ImportRecord } from './types';
import { ImportedUserStatusBadge } from './ImportedUserStatusBadge';

interface ImportedUserTableRowProps {
  record: ImportRecord;
  isProcessing: boolean;
  onProcess: (record: ImportRecord) => void;
}

export const ImportedUserTableRow = ({ record, isProcessing, onProcess }: ImportedUserTableRowProps) => {
  return (
    <TableRow key={record.id}>
      <TableCell className="font-medium">
        {record.first_name} {record.last_name}
      </TableCell>
      <TableCell>{record.email}</TableCell>
      <TableCell>
        <Badge variant={record.role === 'superadmin' ? 'default' : 'secondary'}>
          {record.role === 'superadmin' ? 'Super Admin' : 'Member'}
        </Badge>
      </TableCell>
      <TableCell>
        <ImportedUserStatusBadge status={record.status} invitationStatus={record.invitation_status} />
      </TableCell>
      <TableCell>
        {new Date(record.created_at).toLocaleDateString()}
      </TableCell>
      <TableCell>
        {record.last_invitation_sent ? (
          <span className="text-sm text-gray-600">
            {new Date(record.last_invitation_sent).toLocaleString()}
          </span>
        ) : (
          <span className="text-sm text-gray-400">Never</span>
        )}
      </TableCell>
      <TableCell>
        <div className="flex gap-2">
          {record.status === 'imported' && (
            <Button
              size="sm"
              onClick={() => onProcess(record)}
              disabled={isProcessing}
            >
              {isProcessing ? 'Processing...' : 'Send Invitation'}
            </Button>
          )}
          {record.status === 'invited' && record.invitation_status === 'accepted' && (
            <Badge variant="outline" className="text-xs bg-yellow-100 text-yellow-800">
              User Registered
            </Badge>
          )}
        </div>
      </TableCell>
    </TableRow>
  );
};